import ReactDOM from "react-dom";

import App from "./Components/App";

import "./css/style.css"
import "./css/reset.css"

ReactDOM.render(<App />, document.querySelector(".root"));